import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, Kamitaku } from "@/mixins/index";
import { flowPercent } from "@/api/kamitaku/kamitaku";
export default {
  name: "kamitakuFlow",
  mixins: [tabulation, Kamitaku],
  data: function data() {
    return {
      more: true,
      reqFn: flowPercent,
      searchData: {},
      Calculation: [{
        label: this.$t('personCount'),
        value: 'task_pnum'
      }, {
        label: this.$t('roiPercent'),
        value: 'percent'
      }],
      tableData: [],
      CalculationValue: 'task_pnum',
      StatisticalContent: [{
        label: this.$t('overallFlow'),
        value: '1'
      }, {
        label: this.$t('singleFlowStepLoss'),
        value: '2'
      }],
      StatisticalContentValue: '1',
      isShow: true,
      Dynamic: [],
      totalDynamic: [],
      totalDynamicValue: [],
      data_type: 'main-line-task',
      packingHandle: this.debounce(this.heavy, 500, false)
    };
  },
  created: function created() {// let packingHandleClick = this.throttle(this.heavy, 2000, false);
  },
  methods: {
    totalDynamicChange: function totalDynamicChange(e) {
      var list = [];
      this.isShow = false;
      this.totalDynamic.forEach(function (item, index) {
        e.forEach(function (items, indexs) {
          if (item.value == items) {
            list.push(item);
          }
        });
      });
      this.packingHandle(list);
    },
    // 重设列表
    heavy: function heavy(e) {
      var _this = this;

      this.isShow = false;
      this.Dynamic = [];
      setTimeout(function () {
        _this.Dynamic = e;
        _this.isShow = true;
      }, 100);
    },
    debounce: function debounce(func, wait, immediate) {
      var timeout = null;
      return function () {
        var context = this;
        var args = arguments;
        if (timeout) clearTimeout(timeout);

        if (immediate) {
          var callNow = !timeout;
          timeout = setTimeout(function () {
            timeout = null;
          }, wait);
          if (callNow) func.apply(context, args);
        } else {
          timeout = setTimeout(function () {
            func.apply(context, args);
          }, wait);
        }
      };
    },
    getListnew: function getListnew() {
      var _this2 = this;

      this.reqLoading = true;
      this.getList( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          var total_data, dataValue, keys, DynamicList, _loop, key;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this2.reqLoading = false;
                  total_data = res.total_data;
                  total_data.percent = total_data.percent;
                  dataValue = '';

                  if (_this2.StatisticalContentValue == 1) {
                    dataValue = _this2.CalculationValue;
                  } else {
                    dataValue = 'loss_percent';
                  }

                  keys = Object.keys(res.total_key);
                  keys.sort(function (a, b) {
                    var partsA = a.split('-').map(Number);
                    var partsB = b.split('-').map(Number);

                    for (var i = 0; i < Math.max(partsA.length, partsB.length); i++) {
                      var numA = partsA[i] || 0;
                      var numB = partsB[i] || 0;

                      if (numA > numB) {
                        return -1;
                      } else if (numA < numB) {
                        return 1;
                      }
                    }

                    return 0;
                  });
                  keys = keys.reverse();
                  res.data[_this2.$t('total')] = total_data;
                  DynamicList = [];

                  _loop = function _loop(key) {
                    var data = {
                      date: key
                    };
                    var newList = [];
                    keys.forEach(function (key1) {
                      var checkpoint = res.total_key[key1];
                      data['n' + checkpoint] = dataValue == 'task_pnum' && _this2.StatisticalContentValue == '1' ? res.data[key][dataValue][checkpoint] || 0 : res.data[key][dataValue][checkpoint] > 0 ? (res.data[key][dataValue][checkpoint] * 100).toFixed(2) + "%" : '0%';
                      newList.push({
                        label: checkpoint,
                        value: 'n' + checkpoint
                      });
                    });
                    DynamicList = newList.length > DynamicList.length ? newList : DynamicList;

                    _this2.tableData.push(_objectSpread(_objectSpread({}, res.data[key]), data));
                  };

                  for (key in res.data) {
                    _loop(key);
                  }

                  _this2.Dynamic = [];
                  setTimeout(function () {
                    _this2.totalDynamic = DynamicList;
                    _this2.Dynamic = DynamicList;
                    _this2.totalDynamicValue = DynamicList.map(function (i) {
                      return i.value;
                    });

                    _this2.$nextTick(function () {
                      _this2.getTableRight();
                    });
                  }, 50);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    filterTaskDescDesc: function filterTaskDescDesc(argument) {
      var index = this.TaskDescDescList.findIndex(function (item) {
        return item.task == argument;
      });
      return this.TaskDescDescList[index] ? this.TaskDescDescList[index].desc : argument;
    },
    dataTalos: function dataTalos(newValue) {
      var num = 0;
      var reg = new RegExp('%', 'g');
      this.tableData.forEach(function (item) {
        var k = item[newValue] ? JSON.parse(JSON.stringify(item[newValue]).replace(reg, '')) : 0;
        num += Number(k) || 0;
      });
      return num;
    },
    exportdata: function exportdata() {
      var d = {};
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('newUserNum'),
        prop: 'register_num'
      }];
      var data = [];
      this.Dynamic.map(function (item) {
        columns.push({
          label: item.label,
          prop: item.value
        });
        d[item.value] = 0;
      });
      this.tableData.forEach(function (item) {
        var s = _objectSpread(_objectSpread({}, d), {}, {
          register_num: item.register_num
        });

        for (var key in s) {
          s[key] = item[key];
        }

        s.date = item.date;
        data.push(s);
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};